import { useContext } from 'react';
import DiscoveryContext from '../../../../../contexts/discoveryContext/context';

import { typeOrderedFind, ChildType } from '../../../utils/children';

const getIsDistanceFilterVisible = () => {
  const { parents, distanceList } = useContext(DiscoveryContext) ?? {};

  const parentDistanceLabel =
    parents?.[0]?.labels &&
    typeOrderedFind(parents[0].labels, [ChildType.DISTANCE])?.value;

  const isDistanceFilterVisible =
    parentDistanceLabel && distanceList?.length > 0;

  return {
    isDistanceFilterVisible,
  };
};

const DistanceFilterWrapper = ({ children }) => {
  const isDistanceFilterVisible = getIsDistanceFilterVisible();
  return children(isDistanceFilterVisible);
};

export default DistanceFilterWrapper;
